module.exports = __webpack_public_path__ + "img/goldShadow.8ddbd2bc.webp";